import type { Article } from "../types/content";

import { getSlugFromTitle } from "./getSlugFromTitle";

const getArticleSlug = (article: Article): string => {
  if (article?.meta?.promotion_content?.slug) {
    return article?.meta?.promotion_content?.slug;
  }

  return getSlugFromTitle(article.title.value);
};

export { getArticleSlug };
